import React, { useState } from 'react';
import { get, upperCase } from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  addNotification,
} from '../../lib/helpers';

import {
  useModal,
} from '../../hooks';

import Modal from '../Modal';
import Notification from '../Notification';

const EditTrustParameterModal = ({
  title,
  parameter: { gradingSteps: oldGradingSteps, weight: oldWeight, key, parameterType },
  updateEndpoint
}) => {
  const grades = ['A', 'B', 'C', 'D', 'E']
  const [gradingSteps, setGradingSteps] = useState(oldGradingSteps || {})
  const [weight, setWeight] = useState(oldWeight)
  const [isLoading, setIsLoading] = useState(false)

  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  const onSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)

    axios.put(updateEndpoint, {
      grading_steps: gradingSteps,
      weight: weight,
      authenticity_token: CSRF_TOKEN,
    })
      .then((res) => {
        if (res.status == 200 && get(res, 'data.message')) {
          addNotification({
            message: get(res, 'data.message'),
            type: Notification.NOTIFICATION_TYPES.success,
          })
        }
      })
      .catch((error) => {
        addNotification({
          message: get(error, 'response.data.message'),
          type: Notification.NOTIFICATION_TYPES.error,
        })
      })
      .then(() => {
        // We need to delay this because it's on a worker.
        // So it will not update immediately.
        window.setTimeout(() => {
          window.location.reload()
        }, 3000)
      })
  }

  const handleGradeStepsChange = (e, grade) => {
    setGradingSteps({...gradingSteps, [grade]: +e.target.value })
  }

  return (
    <React.Fragment>
      <a
        onClick={onToggleModal}
        className='Table__controls__a Table__controls__a--pencil'
        title='Edit'
      />
      <Modal
        isActive={modal}
        onToggleModal={onToggleModal}
      >
        <form
          onSubmit={onSubmit}
        >
          <h3 className='Modal__h3'>{title}</h3>

          <div className='EditTrustParameterModal'>
            <div className="Container__form__col">
              <label className='Container__form__label'>Key</label>
              <input
                type='text'
                className='Input'
                placeholder='Key'
                value={key}
                disabled
                readOnly
              />
              <label className='Container__form__label'>Parameter Type</label>
              <input
                type='text'
                className='Input'
                placeholder='Parameter Type'
                value={parameterType}
                disabled
                readOnly
              />
              <label className='Container__form__label'>Grading Steps</label>
              {
                grades.map((grade) => {
                  return (
                    <div className='Input__inline' key={`grading_steps_${grade}`}>
                      <label>{upperCase(grade)}:</label>

                      <input
                        type='number'
                        name={`grading_steps_${grade}`}
                        className='Input'
                        value={get(gradingSteps, grade) || 0}
                        onChange={(e) => handleGradeStepsChange(e, grade)}
                      />
                    </div>
                  )
                })
              }


              <label className='Container__form__label'>Weight</label>
              <input
                type='number'
                name='weight'
                className='Input'
                placeholder='Weight'
                value={weight}
                onChange={(e) => {
                  setWeight(e.target.value)
                }}
              />
            </div>
            <div className='Modal__footer'>
              <a
                className='Button Button--gray-light'
                onClick={onToggleModal}
                disabled={isLoading}
              >
                Cancel
              </a>

              <button
                className='Button Button--blue'
                disabled={isLoading}
                ref={$submitButton}
                onClick={onSubmit}
              >
                {isLoading ? 'Loading …' : 'Update'}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
}

EditTrustParameterModal.propTypes = {
};

export default EditTrustParameterModal;
